import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { paymentFeatureKey, paymentReducer, PaymentEffects } from '@store/payment';


@NgModule({
  imports: [
    StoreModule.forFeature(paymentFeatureKey, paymentReducer),
    EffectsModule.forFeature([ PaymentEffects ]),
  ],
  exports: [
    StoreModule,
  ],
})
export class PaymentFeatureModule { }
